import { Link } from 'react-router-dom';
import { Instagram, Facebook, MessageCircle, Mail, Phone, Star } from 'lucide-react';
import { useSettings } from '../../context/SettingsContext';

export const Footer = () => {
  const { settings } = useSettings();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#07101f] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/brand/logo.jpeg" alt="Arab Diver Tours" className="h-12 w-12 rounded-full object-cover ring-1 ring-[#c8e600]/40" />
            <div>
              <div className="font-display text-lg font-semibold">Arab Diver Tours</div>
              <div className="text-[11px] uppercase tracking-[0.22em] text-white/55">Scuba Diving</div>
            </div>
          </div>
          <p className="mt-4 max-w-md text-sm text-white/65 leading-relaxed">
            A proud division of Aladdin Lamp Tourism (est. 1998). PADI, SDI, TDI and CMAS scuba training, premium Oman dive trips, and dive shop — from Dubai, UAE.
          </p>
          <div className="mt-5 flex items-center gap-3 flex-wrap">
            {settings?.instagram_url && (
              <a data-testid="footer-instagram" href={settings.instagram_url} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/15 hover:border-[#00b4d8] hover:text-[#00b4d8] transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
            )}
            {settings?.facebook_url && (
              <a data-testid="footer-facebook" href={settings.facebook_url} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/15 hover:border-[#00b4d8] hover:text-[#00b4d8] transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
            )}
            {settings?.whatsapp_url && (
              <a data-testid="footer-whatsapp" href={settings.whatsapp_url} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/15 hover:border-[#c8e600] hover:text-[#c8e600] transition-colors">
                <MessageCircle className="h-4 w-4" />
              </a>
            )}
            {settings?.tripadvisor_url && (
              <a data-testid="footer-tripadvisor" href={settings.tripadvisor_url} target="_blank" rel="noopener noreferrer" aria-label="TripAdvisor" className="h-10 px-3 inline-flex items-center justify-center gap-1.5 rounded-full border border-white/15 hover:border-[#34e0a1] hover:text-[#34e0a1] transition-colors text-xs font-semibold">
                <Star className="h-3.5 w-3.5" /> TripAdvisor
              </a>
            )}
            {settings?.google_review_url && (
              <a data-testid="footer-google-review" href={settings.google_review_url} target="_blank" rel="noopener noreferrer" aria-label="Review us on Google" className="h-10 px-3 inline-flex items-center justify-center gap-1.5 rounded-full border border-white/15 hover:border-[#fbbc05] hover:text-[#fbbc05] transition-colors text-xs font-semibold">
                <Star className="h-3.5 w-3.5" /> Google Review
              </a>
            )}
          </div>
        </div>
        <div>
          <div className="font-display font-semibold mb-3 text-white">Explore</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link className="hover:text-white" to="/">Home</Link></li>
            <li><Link className="hover:text-white" to="/about">About Us</Link></li>
            <li><Link className="hover:text-white" to="/courses/sdi">SDI Recreational</Link></li>
            <li><Link className="hover:text-white" to="/courses/tdi">TDI Technical</Link></li>
            <li><Link className="hover:text-white" to="/courses/frti">FRTI Emergency Training</Link></li>
            <li><Link className="hover:text-white" to="/trips">Oman Tours</Link></li>
            <li><Link className="hover:text-white" to="/shop">Shop</Link></li>
            <li><Link className="hover:text-white" to="/team">Our Team</Link></li>
            <li><Link className="hover:text-white" to="/contact">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-semibold mb-3 text-white">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            {settings?.contact_email && (
              <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> <a href={`mailto:${settings.contact_email}`} className="hover:text-white">{settings.contact_email}</a></li>
            )}
            {settings?.contact_phone && (
              <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> <a href={`tel:${settings.contact_phone.replace(/\s/g, '')}`} className="hover:text-white">{settings.contact_phone}</a></li>
            )}
            <li><Link data-testid="footer-contact-link" className="hover:text-white inline-flex items-center gap-2 text-[#00b4d8]" to="/contact">Send us a message →</Link></li>
          </ul>
          <div className="mt-4 text-xs text-white/55">Dubai • UAE • Khasab, Musandam</div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/55">
          <div>© {year} {settings?.footer_copyright || 'Arab Diver Tours'}. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};
